import { db } from '@/main';

const state = {
    todo : []
}

// getters
const getters = {

}

// mutations
const mutations = {
    taskActive:(state,payload)=>{
        var updatestatus = "";
        state.todo.find(function (list) {
            if (list.id == payload) {
                if(list.status == 'ACTIVE'){
                    updatestatus = 'INACTIVE'
                }
                else if(list.status == 'INACTIVE'){
                    updatestatus = 'ACTIVE'
                }
            }
        })

        const updateRef = db.collection('Item').doc(payload);
        updateRef.update({ status:updatestatus })
    },
    alltaskcomplete:(state,payload)=>{
        var updatestatus = "";
        if(payload) {
            updatestatus = 'complete'    
        } else {
            updatestatus = 'incomplete'
        }
        state.todo.forEach(function (list) {
            const updateRef = db.collection('Item').doc(list.id);
            updateRef.update({ status:updatestatus })
        })
    },
    tododelete:(state,payload)=>{
        db.collection('Item').doc(payload).delete()
    },
    addtodo:(state, payload)=>{
        db.collection('Item').add({
            usage: payload.item_usage,
            type : payload.item_type,
            itemId : parseInt(payload.item_id),
            name : payload.item_name,
            info : payload.item_info,
            status : 'INACTIVE',
            created: new Date()
        })
    },
    retrieveTodos(state,todos){
        state.todo = todos
    }

};

// actions
const actions = {
    retrieveTodos:(context)=>{
        db.collection('Item').get()
        .then((querySnapshot)=>{
            var tempTodos = []

            querySnapshot.forEach((doc)=>{
                //tempTodos.push(doc.data());
                //tempTodos.push({ id:doc.id, title:doc.data().title, delete:doc.data().delete, status:doc.data().status, created:doc.data().created });
                tempTodos.push({ id:doc.id, usage:doc.data().usage, type:doc.data().type, itemId:doc.data().itemId, name:doc.data().name, info:doc.data().info, state:doc.data().state, status:doc.data().status, created:doc.data().created });
            })

            var tempTodosSorted = tempTodos.sort((a,b)=>{
                return a.created.seconds - b.created.seconds
            })

            context.commit('retrieveTodos',tempTodosSorted)
        })
    },
    taskActive:(context, payload) => {
        context.commit('taskActive',payload)
    },
    alltaskcomplete:(context,payload) => {
        context.commit('alltaskcomplete',payload)
    },
    tododelete:(context, payload) => {
        context.commit('tododelete',payload)
    },
    addtodo:(context, payload) => {
        context.commit('addtodo', payload)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}